import React from "react";
import { Button } from "@material-ui/core";
import LegalDocument from "../templates/LegalDocument/legal-document";
import { useCookieConsent } from "../../privacy/CookieConsentContext";

export default function CookiePolicy() {
  const { openPreferences } = useCookieConsent();

  return (
    <LegalDocument title="Cookie Policy" effectiveDate="10 September 2026">
      <p>
        This policy describes the cookies and similar technologies used on the
        public website at oxyaorigin.com. Optional technologies remain disabled
        unless you allow them.
      </p>

      <Button color="primary" variant="outlined" onClick={openPreferences}>
        Open Cookie Settings
      </Button>

      <h2>1. Your choices</h2>
      <p>
        You may accept all optional technologies, reject them, or choose by
        category. Refusing optional technologies does not prevent access to the
        public website. You may withdraw consent at any time through Cookie
        Settings in the footer.
      </p>

      <h2>2. Technologies used</h2>
      <table>
        <thead>
          <tr>
            <th>Name or service</th>
            <th>Provider and purpose</th>
            <th>Category</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>oxya_cookie_preferences</td>
            <td>ORIGIN GAME. Records the privacy choices made on this site.</td>
            <td>Essential</td>
            <td>Six months</td>
          </tr>
          <tr>
            <td>_ga and _ga_&lt;measurement-id&gt;</td>
            <td>
              Google Analytics. Measures visits and page use after analytics
              consent.
            </td>
            <td>Analytics</td>
            <td>Up to thirteen months, without renewal</td>
          </tr>
          <tr>
            <td>YouTube cookies and device storage</td>
            <td>
              Google/YouTube. Loads embedded video from youtube-nocookie.com
              after external-media consent.
            </td>
            <td>External media</td>
            <td>Set by Google according to the technology used</td>
          </tr>
        </tbody>
      </table>

      <h2>3. Website delivery and security</h2>
      <p>
        Cloudflare provides website delivery and security. It may use strictly
        necessary technologies to route traffic, identify malicious requests and
        maintain site availability. These functions are not controlled by the
        optional analytics or external-media choices.
      </p>

      <h2>4. Provider information</h2>
      <ul>
        <li>
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Google Privacy Policy
          </a>
        </li>
        <li>
          <a
            href="https://www.cloudflare.com/privacypolicy/"
            target="_blank"
            rel="noreferrer"
          >
            Cloudflare Privacy Policy
          </a>
        </li>
      </ul>

      <h2>5. Contact</h2>
      <p>
        Questions about these technologies or your privacy choices may be sent
        to <a href="mailto:contact@oxyaorigin.com">contact@oxyaorigin.com</a>.
      </p>
    </LegalDocument>
  );
}
